const ABComponentCore = require("../core/ABComponentCore");
module.exports = class ABComponent extends ABComponentCore {};
